// @flow

import { combineReducers, type Reducer } from 'redux';

import { isProduction } from '@zapier/common-utils';

type ReducersMap = { [key: string]: Reducer<any, any> };

const deepFreeze = (obj: {}) => {
  Object.freeze(obj);

  Object.getOwnPropertyNames(obj).forEach(function (prop) {
    if (
      Object.prototype.hasOwnProperty.call(obj, prop) &&
      obj[prop] !== null &&
      (typeof obj[prop] === 'object' || typeof obj[prop] === 'function') &&
      !Object.isFrozen(obj[prop])
    ) {
      deepFreeze(obj[prop]);
    }
  });

  return obj;
};

const freezeState = isProduction() ? state => state : deepFreeze;

export default (reducers: ReducersMap) => {
  const reducer = combineReducers(reducers);
  return (...args: []) => {
    const state = reducer(...args);
    return freezeState(state);
  };
};
